export const FMT_LOCAL_DATE = 'l';
export const FMT_TIME = 'h:mm a';

export const DATE_FORMATS = [
  // Month-first formats
  'MMM D',
  'MMM D YY',
  'MMM D YYYY',
  'MMM D, YY',
  'MMM D, YYYY',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'M/D/YY',
  'M/D/YYYY',
  'MM-DD-YYYY',
  'MM-DD-YY',
  'M-D-YY',
  'M-D-YYYY',

  // Year-first format
  'YYYY-MM-DD',

  // Locale-specific shorthand (moment "l")
  FMT_LOCAL_DATE,
];

export const TIME_FORMATS = ['h:mma', FMT_TIME];
